var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 69",
    className: "design-iconfont",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "0b6acf9yec"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9945B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F94B23",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "w86j0gfrkb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB083",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7A5C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.0784394%",
    y1: "29.6228472%",
    x2: "91.088602%",
    y2: "71.9480835%",
    id: "y3rcr1skoe"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE9E1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE9E1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-44%",
    y: "-37%",
    width: "187.9%",
    height: "173.9%",
    filterUnits: "objectBoundingBox",
    id: "x0kr8osspa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.329116928 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-48%",
    y: "-63.2%",
    width: "196%",
    height: "226.3%",
    filterUnits: "objectBoundingBox",
    id: "k5aso86wsd"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.976470588 0 0 0 0 0.321568627 0 0 0 0 0.156862745 0 0 0 1 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#x0kr8osspa)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,4 C35.3506307,4 41.0997889,6.58913593 45.2614593,10.7744092 C49.4251707,14.9617352 52,20.7466044 52,27.1361163 C52,32.6616494 48.5782888,39.4412816 44.3475291,45.410863 C38.7842583,53.2606113 31.7296255,60 29,60 C26.2703745,60 19.2157417,53.2606113 13.6524709,45.410863 C9.42171119,39.4412816 6,32.6616494 6,27.1361163 C6,20.7466044 8.57482926,14.9617352 12.7385407,10.7744092 C16.9002111,6.58913593 22.6493693,4 29,4 Z",
    stroke: "url(#w86j0gfrkb)",
    strokeWidth: 2,
    fill: "url(#0b6acf9yec)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#k5aso86wsd)",
    transform: "translate(17 18)",
    fill: "url(#y3rcr1skoe)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.46037771,7.45328275 L2.77032031,7.45328275 L2.77032031,14.1497277 L1.46037771,14.1497277 L1.46037771,7.45328275 Z M2.13617849,13.3405739 C2.69625995,13.3405739 3.20079615,13.6800465 3.41371968,14.1962308 C3.62664321,14.7170654 3.5109239,15.312305 3.11284947,15.7122315 C2.71940381,16.1075078 2.12229217,16.2284158 1.60386965,16.0145016 C1.08544714,15.8005874 0.752175523,15.2937037 0.752175523,14.7310163 C0.752175523,14.3636419 0.895667469,14.0102184 1.1595075,13.7498011 C1.41871876,13.4847335 1.77050546,13.3405739 2.13617849,13.3405739 L2.13617849,13.3405739 Z M6.48722459,9.24830203 L18.7581004,9.24830203 C18.9571376,9.24830203 19.151546,9.32735728 19.2904092,9.47151686 C19.4339011,9.61567644 19.5125903,9.80633911 19.5125903,10.0063024 L19.5125903,16.3725754 C19.5125903,16.7911032 19.1561748,17.1305758 18.7581004,17.4328459 C18.7581004,17.4328459 15.5549898,19 12.4213109,19 C9.42186632,19 6.48722459,17.4328459 6.48722459,17.4328459 C5.96880207,17.1119745 5.73273468,16.6887964 5.73273468,16.2702686 L5.73273468,10.0063024 C5.73273468,9.80633911 5.81142381,9.61102613 5.95491576,9.47151686 C6.09377893,9.32735728 6.28818737,9.24830203 6.48722459,9.24830203 Z M7.71847806,10.2341675 L17.5268469,10.2341675 C17.8601185,10.2341675 18.1285873,10.4945848 18.1285873,10.8108058 L18.1285873,15.6610781 C18.1285873,15.9819495 18.073042,16.2330661 17.5268469,16.4702319 C17.5268469,16.4702319 14.9671357,17.6653613 12.4629698,17.6653613 C10.0652657,17.6653613 7.71847806,16.4702319 7.71847806,16.4702319 C7.19542677,16.2935202 7.11673764,15.9028942 7.11673764,15.5866732 L7.11673764,10.8108058 C7.11673764,10.4899345 7.38520644,10.2341675 7.71847806,10.2341675 Z M13.5229587,0.226702564 L24.5764673,6.16979747 C25.1411776,6.47206755 25.1411776,6.96500031 24.5764673,7.2719207 L13.5229587,13.2150156 C12.9582485,13.5172857 12.0417515,13.5172857 11.4770413,13.2150156 L0.423532679,7.2719207 C-0.14117756,6.96965061 -0.14117756,6.47671786 0.423532679,6.16979747 L11.4770413,0.226702564 C12.0417515,-0.0755675213 12.9582485,-0.0755675213 13.5229587,0.226702564 Z M13.3378078,1.68689959 L22.2898537,6.22095087 C22.7481022,6.45346632 22.7481022,6.83014134 22.2898537,7.06265679 L13.3378078,11.5967081 C12.8795593,11.8292235 12.1389557,11.8292235 11.6807073,11.5967081 L2.73329013,7.06265679 C2.27504166,6.83014134 2.27504166,6.45346632 2.73329013,6.22095087 L11.685336,1.68689959 C12.1389557,1.45903445 12.8841881,1.45903445 13.3378078,1.68689959 L13.3378078,1.68689959 Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.bff07decbee802ff55470c46cc3e760e.svg";
export { ForwardRef as ReactComponent };